<span>{{ formattedPrice$ | async }}</span>